@if (spec) {
    <div class="field">
        <label soho-label for="lm-builder-list-sharing">{{ 'CreateReportSharing' | translate }}</label>
        <select
                soho-dropdown
                soho-trackdirty
                id="lm-builder-list-sharing"
                name="lm-builder-list-sharing"
                data-automation-id="lm-builder-list-sharing-dropdown"
                [attributes]="allowSharingIDSAttributes"
                data-validate="validateRequired"
                [(ngModel)]="sharing"
                (ngModelChange)="updateSharing()">
            @for (option of sharingOptions; track option.value) {
                <option [value]="option.value">{{option.label}}</option>
            }
        </select>
    </div>

    @if (sharing === 'roleGroup') {
        <div class="field">
            <label soho-label for="lm-builder-sharing-role-group-target" class="required">{{ 'CreateReportRoleGroupLabel' | translate }}</label>
            <input #roleGroupSharingLookupComponent
                id="lm-builder-sharing-role-group-target"
                data-automation-id="lm-builder-sharing-role-group-target"
                soho-lookup
                soho-trackdirty
                [click]="sharingLookupClick"
                [field]="sharingSelectField"
                data-validate="validateRequired"
                [(ngModel)]="roleGroup"
                (ngModelChange)="updateSharingTarget()"/>
        </div>
    }
    @if (sharing === 'actorGroup') {
        <div class="field">
            <label soho-label for="lm-builder-sharing-target-actor-group" class="required">{{ 'CreateReportActorGroupLabel' | translate }}</label>
            <input #actorGroupLookupComponent
               id="lm-builder-sharing-target-actor-group"
               data-automation-id="lm-builder-sharing-target-actor-group"
               soho-lookup
               soho-trackdirty
               [click]="sharingLookupClick"
               [field]="sharingSelectField"
               data-validate="validateRequired"
               [(ngModel)]="actorGroup"
               (ngModelChange)="updateSharingTarget()"/>
        </div>
    }
    @if (sharing === 'role') {
        <div class="field">
            <label soho-label for="lm-builder-sharing-target-role" class="required">{{ 'CreateReportRoleLabel' | translate }}</label>
            <input #roleLookupComponent
               id="lm-builder-sharing-target-role"
               data-automation-id="lm-builder-sharing-target-role"
               soho-lookup
               soho-trackdirty
               [click]="sharingLookupClick"
               [field]="sharingSelectField"
               data-validate="validateRequired"
               [(ngModel)]="role"
               (ngModelChange)="updateSharingTarget()"/>
        </div>
    }
}
